import callbackMapping from '@framework/message/Mapper/callbackMapping';
import isServer from '@framework/router/Next/isServer';
import Container from '@framework/di/Container';

declare global {
  interface Window {
    execCallback: (type: string, params: string) => void,
    gtag: (action: string, eventName: string, params?: object) => void,
  }
}

const registerMessagesExecCallback = (container: Container) => {
  const execCallback = (type: string, params: string) => {
    if (!(callbackMapping as any)[type]) {
      throw `Callback ${ type } was not found in message callback mapping`;
    }
    (callbackMapping as any)[type](container, JSON.parse(decodeURIComponent(params)));
  };

  if (!isServer()) {
    window.execCallback = execCallback;
  }
};

export default registerMessagesExecCallback;
